import React from 'react';
import { ReduxAppCreator, SentrySDK } from 'UI-Dash-Commons-UI';
import FrameCollection from './modules/FrameCollection/index';
import NotificationRootComponent from './modules/FrameCollection/components/NotificationRootComponent';
import MainNavigationContainer from './modules/MainNavigation';
import reducer from './redux/reducer';
import WrapperInit from './utils/WrapperInit';
import AppHistory from './utils/AppHistory';

WrapperInit.init();

ReduxAppCreator.createApp(
    'Wrapper',
    reducer,
    <MainNavigationContainer>
        <FrameCollection/>
        <NotificationRootComponent/>
    </MainNavigationContainer>,
    { appHistory: AppHistory, enableFrameCollection: false }
);
